import { HttpXsrfTokenExtractor } from '@angular/common/http';
import { RxStompConfig } from '@stomp/rx-stomp';
import { ConfigurationService } from '../api/configuration.service';
import { NotificationsService } from '../api/notifications.service';

export class TemenosRxStompConfig extends RxStompConfig {

  constructor(private httpXsrfTokenExtractor: HttpXsrfTokenExtractor,
    private notificationsService: NotificationsService,
    private configurationService: ConfigurationService) {
    
super();
    this.connectHeaders = {
      'client-id': 'portal-interface',
      'X-XSRF-TOKEN': this.httpXsrfTokenExtractor.getToken()
    };
    // How often to heartbeat?
    // Interval in milliseconds, set to 0 to disable
    this.heartbeatIncoming = 0; // Typical value 0 - disabled
    this.heartbeatOutgoing = 20000; // Typical value 20000 - every 20 seconds

    // Wait in milliseconds before attempting auto reconnect
    // Set to 0 to disable
    // Typical value 500 (500 milli seconds)
    this.reconnectDelay = 5000;

    this.beforeConnect = (stompClient: any): Promise<void> =>
      new Promise<void>((resolve, reject) => {
        this.configurationService.getConfiguration()
          .subscribe({
            next: (configuration) => {
              this.notificationsService.getToken()
                .subscribe({
                  next: (jwtToken) => {
                    stompClient.stompClient.brokerURL = `${configuration.wsNotificationsUrl}/messages?jwt=${jwtToken.value}`;
                    resolve();
                  }
                });
            }, error: (err) => {
              resolve();
            },
          });
      });
  }
};
